export enum IncidentStatuses {
  IN_PROGRESS = 'in-progress',
  RESOLVED = 'resolved',
  DELETED = 'deleted',
}

export const translateIncidentStatus = (status: string) => {
  switch (status) {
    case IncidentStatuses.IN_PROGRESS:
      return 'En cours';
    case IncidentStatuses.RESOLVED:
      return 'Résolu';
    case IncidentStatuses.DELETED:
      return 'Supprimé';
    default:
      return '';
  }
};

export const selectIncidentStatuses = Object.values(IncidentStatuses).map(
  (s) => ({
    id: s,
    label: translateIncidentStatus(s),
  }),
);

export enum IncidentTypesSlugs {
  PLUMBING = 'plumbing',
  AERATION = 'aeration',
  ELEVATOR = 'elevator',
  MAIL_BOX = 'mail-box',
  HEATER = 'heater',
  LIGHTING = 'lighting',
  ACCESS = 'access',
  FIRE = 'fire',
  GREEN_SPACE = 'green-space',
  CLEANLINESS = 'cleanliness',
  INFECTION = 'infection',
  CARPENTRY = 'carpentry',
  MASONRY = 'masonry',
  NETWORK = 'network',
  OTHER = 'other',
}

export const incidentTypes = [
  {
    id: IncidentTypesSlugs.PLUMBING,
    label: 'Plomberie / Fuite',
  },
  {
    id: IncidentTypesSlugs.AERATION,
    label: 'Aération / VMC',
  },
  {
    id: IncidentTypesSlugs.ELEVATOR,
    label: 'Ascenseur',
  },
  {
    id: IncidentTypesSlugs.MAIL_BOX,
    label: 'Boites aux lettres',
  },
  {
    id: IncidentTypesSlugs.HEATER,
    label: 'Chauffage',
  },
  {
    id: IncidentTypesSlugs.LIGHTING,
    label: 'Electricité / Eclairage',
  },
  {
    id: IncidentTypesSlugs.GREEN_SPACE,
    label: 'Espaces verts',
  },
  {
    id: IncidentTypesSlugs.FIRE,
    label: 'Incendie',
  },
  {
    id: IncidentTypesSlugs.ACCESS,
    label: 'Accès / Portail',
  },
  {
    id: IncidentTypesSlugs.CLEANLINESS,
    label: 'Propreté',
  },
  {
    id: IncidentTypesSlugs.INFECTION,
    label: 'Nuisible / Infection',
  },
  {
    id: IncidentTypesSlugs.CARPENTRY,
    label: 'Menuiserie',
  },
  {
    id: IncidentTypesSlugs.MASONRY,
    label: 'Maçonnerie / Revêtement',
  },
  {
    id: IncidentTypesSlugs.NETWORK,
    label: 'TV / accès internet / réseau téléphonique',
  },
  {
    id: IncidentTypesSlugs.OTHER,
    label: 'Autre',
  },
];
